export const AUTH = 'auth';
export const BANK_ACCOUNTS = 'bank-accounts';
export const PAYMENT_ORDERS = 'payment-orders';
export const DIRECT_DEBIT = 'sepa/direct-debit';
export const E_IRA = 'e-ira';

export default {
  AUTH,
  BANK_ACCOUNTS,
  PAYMENT_ORDERS,
  E_IRA,
  DIRECT_DEBIT,
};
